import React, { useEffect, useRef } from 'react'
import scrollIntoView from 'scroll-into-view-if-needed'

export default function ScrollIntoViewIf({
  condition = false,
  behavior = 'smooth',
  scrollMode = 'always',
  block = 'start',
  inline = 'start',
  delay = 0,
}) {
  let ref = useRef(null)
  useEffect(() => {
    if (!condition) return
    requestAnimationFrame(() => {
      setTimeout(() => {
        if (ref.current) {
          scrollIntoView(ref.current, {
            behavior,
            scrollMode,
            block,
            inline,
          })
        }
      }, delay)
    })
  }, [behavior, scrollMode, block, inline, delay, condition])
  return <span ref={ref} />
}
